import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <Link to="/" className="logo">
              <img src="/proofsec.png" width="168" height="48" alt="ProofSec Logo" className="logo-image" />
            </Link>
            <p className="footer-tagline">
              Independent smart contract audits and secure Web3 development. Proof, not promises.
            </p>
            <div className="footer-social">
              <a href="https://x.com/proof_sec" className="social-link" target="_blank" rel="noopener noreferrer">X</a>
              <a href="https://www.linkedin.com/company/proofsecxyz" className="social-link" target="_blank" rel="noopener noreferrer">LinkedIn</a>
              <a href="https://www.youtube.com/@proof_sec" className="social-link" target="_blank" rel="noopener noreferrer">YouTube</a>
            </div>
          </div>
          <div className="footer-columns">
            <div className="footer-column">
              <h4 className="footer-heading">Services</h4>
              <a href="/#services" className="footer-link">Audit Services</a>
              <a href="/#development" className="footer-link">Development</a>
              <a href="/#process" className="footer-link">Process</a>
              <a href="/#methodology" className="footer-link">Methodology</a>
              <a href="/#sample" className="footer-link">Sample Report</a>
            </div>
            <div className="footer-column">
              <h4 className="footer-heading">Resources</h4>
              <Link to="/hacks" className="footer-link">Smart Contract Hacks</Link>
              <Link to="/scammers" className="footer-link">Scammer Awareness</Link>
            </div>
            <div className="footer-column">
              <h4 className="footer-heading">Company</h4>
              <a href="/#home" className="footer-link">Home</a>
              <Link to="/privacy" className="footer-link">Privacy Policy</Link>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>Copyright © 2025 ProofSec. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
